import React from 'react'
import './styles/slider.scss'

const Slider = ({
    style,
    cssClass,
    onChange,
    name,
    defaultChecked,
    value,
    label,
}) => {
    const onChangeOverride = (e) => {
        e.stopPropagation()
        const { checked } = e.target

        if (typeof onChange === 'function') {
            onChange({ value: checked, name }, e)
        }
    }

    return (
        <div className="sliderContainer" id="uc-slider">
            <div>
                {label}
            </div>
            <div className="control">
                <label className={`sliderSwitch ${cssClass || ''}`} style={style}>
                    <input type="checkbox" onChange={onChangeOverride} defaultChecked={defaultChecked} checked={value} />
                    <span className="uc-slider" />
                </label>
            </div>
        </div>
    )
}

export default Slider
